import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export enum ViewSpacing {
  NONE = 0,
  X_SMALL = 8,
  SMALL = 16,
  MEDIUM_SMALL = 20,
  MEDIUM = 24,
  LARGE = 32,
  X_LARGE = 40,
}

export enum ViewDirection {
  ROW = 'row',
  COLUMN = 'column',
}

export enum ViewJustify {
  START = 'start',
  END = 'end',
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
}

export enum ViewAlign {
  START = 'start',
  END = 'end',
  CENTER = 'center',
  BASELINE = 'baseline',
}

@Component({
  standalone: true,
  selector: 'app-view',
  imports: [CommonModule],
  templateUrl: './view.component.html',
  styleUrl: './view.component.css',
})
export class ViewComponent {
  @Input() direction = ViewDirection.ROW;
  @Input() justify = ViewJustify.START;
  @Input() align = ViewAlign.START;
  @Input() spacingTop = ViewSpacing.NONE;
  @Input() spacingBottom = ViewSpacing.NONE;
  @Input() columnGap = ViewSpacing.NONE;
  @Input() rowGap = ViewSpacing.NONE;
  @Input() gap = ViewSpacing.NONE;
  @Input() padding = '0';
}
